import { GenericInputTextAreaStyle } from './styles';

const GenericInputTextArea = ({ ...props }: any) => {
  return <GenericInputTextAreaStyle {...props} />;
};

export default GenericInputTextArea;
